import getCurrencyToSymbolMap from 'currency-symbol-map';

import { SupportedLocales } from '../../api/types';

const currencyOnTheLeft = [
  'ARS',
  'AUD',
  'BRL',
  'CAD',
  'CLP',
  'CNY',
  'COP',
  'DKK',
  'HKD',
  'INR',
  'ILS',
  'JPY',
  'KRW',
  'MYR',
  'MXN',
  'NZD',
  'NOK',
  'PHP',
  'SGD',
  'ZAR',
  'CHF',
  'TWD',
  'GBP',
  'USD',
];

function isLocaleSupported(locale: SupportedLocales) {
  return Intl.NumberFormat.supportedLocalesOf([locale]).includes(locale);
}

function defaultCurrencyFormat(
  currency: string,
  value: number,
  locale: SupportedLocales,
) {
  const currencySymbol = getCurrencyToSymbolMap(currency);
  const verifiedSymbol =
    currencySymbol !== undefined ? currencySymbol : currency;
  let formattedValue = value.toString();

  if (isLocaleSupported(locale)) {
    formattedValue = new Intl.NumberFormat(locale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  }

  if (currencyOnTheLeft.indexOf(currency) > -1) {
    return `${verifiedSymbol} ${formattedValue}`;
  }

  return `${formattedValue} ${verifiedSymbol}`;
}

export function formatPrice(
  locale: SupportedLocales,
  currency: string,
  value: string | number,
) {
  const numberValue = typeof value === 'number' ? value : parseFloat(value);
  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      currencyDisplay: 'narrowSymbol',
    }).format(numberValue);
  } catch (err) {
    return defaultCurrencyFormat(currency, numberValue, locale);
  }
}

export default formatPrice;
